module.exports = __webpack_public_path__ + "img/main_visual2.14e9d0aa.png";